import { Form } from 'antd'
import { t } from 'i18next'
import { useCallback, useMemo, useState } from 'react'
import { ModalBase, ModalContentContainer } from '../../../../../components'
import { optionalRequiredMark } from '../../../../../constants/constants'
import SmartFunctionActionDropdownDropDownItem from '../../../components/SmartFunctionActionDropdown/SmartFunctionActionDropdownDropDownItem'
import CompensationMatrixAnalysisLastConfigurationModalFooter from './footer/CompensationMatrixAnalysisLastConfigurationModalFooter'
import CompensationMatrixAnalysisLastConfigurationModalStep from './Steps/CompensationMatrixAnalysisLastConfigurationModalStep'

export interface CompensationMatrixAnalysisConfigurationValues {
  ssr?: string
  experimentName?: string
  manuallySelectExperimentRun?: boolean
  selectedExperimentRuns?: string[]
  signalDifferenceSensitivity?: string
  foldChangeSensitivity?: string
  outlierHandlingLevel?: string
}

const CompensationMatrixAnalysisLastConfigurationModal = () => {
  const [form] = Form.useForm<CompensationMatrixAnalysisConfigurationValues>()

  const [open, setOpen] = useState(false)

  const handleOk = useCallback(() => {
    setOpen(false)
  }, [])

  const handleCancel = useCallback(() => {
    setOpen(false)
  }, [])

  const defaultValues: CompensationMatrixAnalysisConfigurationValues = useMemo(
    () => ({
      ssr: undefined,
      experimentName: undefined,
      manuallySelectExperimentRun: undefined,
      selectedExperimentRun: undefined,
    }),
    [],
  )

  return (
    <>
      <SmartFunctionActionDropdownDropDownItem
        onClick={() => {
          setOpen(true)
        }}
      >
        {t(
          'workspaceDetailsPage.workspaceSmartFunctionPanel.actionMenu.viewRunSetup',
        )}
      </SmartFunctionActionDropdownDropDownItem>
      <ModalBase
        key="main"
        title={t(
          'compensationMatrixAnalysisConfigurationModal.lastConfiguration.title',
        )}
        open={open}
        onOk={handleOk}
        onCancel={handleCancel}
        destroyOnClose
        width={720}
        footer={
          <CompensationMatrixAnalysisLastConfigurationModalFooter
            onClose={handleCancel}
          />
        }
        styles={{
          body: {
            maxHeight: 'calc(100vh - 400px)',
          },
        }}
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={defaultValues}
          requiredMark={optionalRequiredMark}
        >
          <ModalContentContainer>
            <CompensationMatrixAnalysisLastConfigurationModalStep />
          </ModalContentContainer>
        </Form>
      </ModalBase>
    </>
  )
}

export default CompensationMatrixAnalysisLastConfigurationModal
